export interface CarouselItem {
  id: number,
  title: string,
  content: string,
  excerpt: string,
  thumbnail_url: string,
  thumbnail_url_medium: string,
  thumbnail_url_small: string,
}
